import Vue from 'vue';
import ErrorPage from './error.vue';

export const errorPage = (message: string) => {
    new Vue({
        render: h => h(ErrorPage, { props: { message } })
    }).$mount('body>div');
};
